const dateTimeFormatter = new Intl.DateTimeFormat("pt-br");

export default dateTimeFormatter;
